module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/log-table/log-table.component.sass
// module id = ./src/app/modules/user/components/log-table/log-table.component.sass
// module chunks = main